export default {
  'search-val': '', offset: 0, limit: 100, 'page-number': 0,
};
